import React, { useState, useEffect, useContext, useCallback } from "react";
import { Link, Redirect, withRouter } from "react-router-dom";
import { Table, Icon, Modal, notification, Menu, Dropdown } from "antd";
import DrawerDoc from "./Drawer/DrawerDoc";
import ModalViewer from "../../../shared/components/Modals/ModalViewer";
import { GlobalContext } from "../../../app/providers/GlobalState";
import axios from "axios";
import { FaFile, FaFolderOpen } from "react-icons/fa";
import { montarIcon } from "../../../shared/utils/Drive/file/getFileIcon";
import { downloadFile } from "../../../shared/utils/fileDownloader";

const confirm = Modal.confirm;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const Tabela = ({ carregarAnosDocumentos, match }) => {
    const globalContext = useContext(GlobalContext);
    const [documento, setDocumento] = useState(null);
    const [documentos, setDocumentos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [redirectLink, setRedirectLink] = useState("");
    const [visible, setVisible] = useState(false);
    const [docs, setDocs] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);

    const [dataSource, setDataSource] = useState([]);
    const [breadcrumb, setBreadcrumb] = useState([]);

    const [pastaAtual, setPastaAtual] = useState(null);

    const extensions = [
        ".bmp",
        ".csv",
        ".odt",
        ".doc",
        ".docx",
        ".gif",
        ".htm",
        ".html",
        ".jpg",
        ".jpeg",
        ".pdf",
        ".png",
        ".ppt",
        ".pptx",
        ".tiff",
        ".txt",
        ".xls",
        ".xlsx"
    ];

    const columns = [
        {
            title: "Nome",
            dataIndex: "nome",
            key: "nome",
            render: (text, record) => {
                if (["pasta", "turma", "disciplina"].includes(record.tipo)) {
                    return (
                        <span onClick={() => handlePastaAtualId(record)} className="nome-ficheiro-icon">
                            <FaFolderOpen size={20} color={"#f5ca5a"} /> {text}
                        </span>
                    );
                }
                return (
                    <a
                        style={{ color: "rgba(0,0,0,0.65)" }}
                        className="nome-ficheiro-icon"
                        href={record.ficheiro}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={e => e.stopPropagation()}
                    >
                        {montarIcon(record)} {text}
                    </a>
                );
            }
        },
        {
            title: "Data",
            dataIndex: "dt_criado",
            render: (text, record) => (text ? text.split("T")[0] : "-")
        },

        {
            title: "",
            dataIndex: "",
            render: (text, record) => {
                return (
                    <div className="pasta-controlos">
                        {extensions.find(x => x === record.extensao) && (
                            <Link
                                to="#"
                                title="Visualizar"
                                className="botao-icon-detalhe"
                                onClick={() => {
                                    setModalVisible(true);
                                    setDocs([{ uri: record.ficheiro }]);
                                }}
                            >
                                <Icon type="eye" />
                            </Link>
                        )}
                        {record.proprio && (
                            <>
                                <Link
                                    className="botao-icon-editar"
                                    to="#"
                                    onClick={() => {
                                        setDocumento(record);
                                        setVisible(true);
                                    }}
                                    title="Editar"
                                >
                                    <Icon type="edit" />
                                </Link>
                                <Link className="botao-icon-excluir" to="#" onClick={() => excluir(record.id)} title="Excluir">
                                    <Icon type="delete" />
                                </Link>
                            </>
                        )}
                    </div>
                );
            }
        }
    ];

    const columnsMobile = [
        {
            title: "Nome",
            dataIndex: "nome",
            key: "nome",
            render: (text, record) => {
                if (["pasta", "turma", "disciplina"].includes(record.tipo)) {
                    return (
                        <span onClick={() => handlePastaAtualId(record)} className="nome-ficheiro-icon">
                            <FaFolderOpen size={20} color={"#f5ca5a"} /> {text}
                        </span>
                    );
                }
                return (
                    <a
                        style={{ color: "rgba(0,0,0,0.65)" }}
                        className="nome-ficheiro-icon"
                        href={record.ficheiro}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={e => e.stopPropagation()}
                    >
                        {montarIcon(record)} {text}
                    </a>
                );
            }
        },
        {
            title: "Data",
            dataIndex: "dt_criado",
            render: (text, record) => (text ? text.split("T")[0] : "-")
        },

        {
            title: "",
            dataIndex: "",
            render: (text, record) => {
                const podeVisualizar = extensions.includes(record.extensao);
                return podeVisualizar && <div className={"pasta-controlos"}>{montarFicheirosMobile(record)}</div>;
            }
        }
    ];

    const montarFicheirosMobile = documento => {
        return (
            <Dropdown overlay={opcoesMobile(documento)} placement="bottomLeft" trigger={["click"]}>
                <a className="botao-icon-configs" onClick={e => e.preventDefault()}>
                    <i className="fas fa-cog" />
                </a>
            </Dropdown>
        );
    };

    const opcoesMobile = documento => {
        return (
            <Menu>
                <Menu.Item key="visualizar">
                    <Link
                        to="#"
                        title="Visualizar"
                        /*className="botao-icon-detalhe"*/
                        onClick={() => {
                            setModalVisible(true);
                            setDocs([{ uri: documento.ficheiro }]);
                        }}
                    >
                        Visualizar
                    </Link>
                </Menu.Item>

                {documento.proprio && (
                    <Menu.Item key="editar">
                        <Link
                            to="#"
                            onClick={() => {
                                setVisible(true);
                                setDocumento(documento);
                            }}
                            title="Editar"
                        >
                            Editar
                        </Link>
                    </Menu.Item>
                )}
                {documento.proprio && (
                    <Menu.Item key="excluir">
                        <Link
                            /*className="botao-icon-excluir"*/
                            to="#"
                            onClick={() => excluir(documento.id)}
                            title="Excluir"
                        >
                            Excluir
                        </Link>
                    </Menu.Item>
                )}
            </Menu>
        );
    };

    const handlePastaAtualId = record => {
        setPastaAtual(record);
        //Todos Ficheiros
        if (record.id === null) {
            setDataSource(documentos.filter(p => p.tipo === "turma").map(p => p));
            setBreadcrumb([{ id: null, nome: "Todos Ficheiros" }]);
            return;
        }

        const pastasMostrar = documentos.filter(f => f.pastaPai === record.id).map(f => f);

        const ficheiros = (record?.ficheiros || []).map(f => ({
            key: f.id,
            id: f.id,
            nome: f.nome,
            disciplinaId: f.disciplinaId,
            tipo: "ficheiro",
            dt_criado: f.dt_criado,
            ficheiro: f.ficheiro,
            extensao: f.extensao,
            proprio: f.proprio
        }));
        setDataSource([...pastasMostrar, ...ficheiros]);

        // Breadcrumb
        const caminho = (record?.niveis || []).map(nivelId => documentos.find(p => p.id === nivelId) ?? null).filter(Boolean);

        setBreadcrumb([{ id: null, nome: "Todos Ficheiros" }, ...caminho]);
    };

    const download = documento => {
        axios({
            method: "post",
            url: "/api/curso-fichs/download-ficheiro",
            params: {
                documentoId: documento.id,
                cursoId: documento.disciplinaId
            }
        })
            .then(response => {
                const fileUrl = response.data.url;
                const fileName = response.data.nome;

                downloadFile(fileName, fileUrl);
            })
            .catch(error => {
                /*if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
                else openNotificationWithIcon("error", "Erro", error.response.data);

                this.setState({ iconLoading: false });*/
            });
    };

    const excluir = documentoId => {
        confirm({
            title: "Pretende excluir este ficheiro?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "put",
                    url: "/api/documentos/excluir",
                    params: {
                        documentoId
                    }
                })
                    .then(response => {
                        openNotificationWithIcon("success", "Sucesso", "Ficheiro excluido!");
                        //const _documentos = documentos.filter(x => x.key !== documentoId);
                        //setDocumentos(_documentos);

                        carregarFicheiros();
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível excluir o ficheiro!");
                    });
            }
        });
    };

    const carregarFicheiros = () => {
        setLoading(true);
        axios({
            method: "get",
            url: "/api/documentos/listar-utilizador",
            params: {
                code: match.params.code,
                ano: globalContext[`ano${match.params.code}`]
            }
        })
            .then(response => {
                setDocumentos(response.data);

                if (pastaAtual === null) {
                    setBreadcrumb([{ id: null, nome: "Todos Ficheiros" }]);
                    setDataSource(response.data.filter(x => x.tipo == "turma"));
                } else {
                    handlePastaAtualId(response.data.filter(x => x.id === pastaAtual.id)[0]);
                }
                setLoading(false);
            })
            .catch(error => {
                if (error.response.status === 401) {
                    setRedirectLink("/login");
                    setRedirect(true);
                }
                setLoading(false);
            });
    };

    useEffect(() => {
        carregarFicheiros();
    }, []);
    if (redirect) return <Redirect to={redirectLink} />;

    return (
        <>
            <div className="area-drive">
                <div className={"breadcrumb"}>
                    {breadcrumb.map((item, index) => (
                        <span key={item.id}>
                            <span style={{ cursor: "pointer", fontWeight: "bold" }} onClick={() => handlePastaAtualId(item)}>
                                {item.nome}
                            </span>

                            {index < breadcrumb.length - 1 && " / "}
                        </span>
                    ))}
                </div>
                {dataSource && (
                    <>
                        <div className="desktop-only">
                            {dataSource && <Table className="tabela" dataSource={dataSource} columns={columns} />}
                        </div>
                        <div className="mobile-only">
                            {dataSource && <Table className="tabela" dataSource={dataSource} columns={columnsMobile} />}
                        </div>
                    </>
                )}
            </div>

            {/* <div className="opcoes-meus-cursos">
                <Link
                    to="#"
                    className="btn-adicionar"
                    title="Adicionar"
                    onClick={() => {
                        setVisible(true);
                        setDocumentoId(0);
                    }}
                >
                    +
                </Link>
            </div>*/}
            <DrawerDoc
                download={download}
                documento={documento}
                visible={visible}
                onClose={() => setVisible(false)}
                atualizar={() => {
                    setVisible(false);
                    carregarFicheiros();
                }}
            />
            <ModalViewer visible={modalVisible} docs={docs} onCancel={() => setModalVisible(false)} />
        </>
    );
};

export default withRouter(Tabela);
